const Ipo = () => import('@/view/ipo/Ipo.vue')
const IpoDetail = () => import('@/view/ipo/IpoDetail.vue')
const IpoFaq = () => import('@/view/ipo/IpoFaq.vue')
const IpoSubmitSuccess = () => import('@/view/ipo/IpoSubmitSuccess.vue')

const routes = [
  {
    path: '/ipo',
    component: Ipo,
  },
  {
    path: '/ipo/subscription',
    component: Ipo,
    props: { defaultTab: 'mine' },
  },
  {
    path: '/ipo/detail',
    component: IpoDetail,
    props: route => ({ id: route.query.id }),
  },
  {
    path: '/ipo/faq',
    component: IpoFaq,
  },
  {
    path: '/ipo/success',
    component: IpoSubmitSuccess,
    props: route => ({
      id: route.query.id,
      copies: route.query.copies,
      name: route.query.name,
      code: route.query.code,
      allotmentTime: route.query.allotmentTime,
    }),
  },
]

const components = {}

export default {
  routes,
  components,
}
